import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@sundae/ui-toolkit";
import cx from "classnames";
import { useBrandConfig } from "../../hooks";
export const Banner = ({ title, description }) => {
    const brand = useBrandConfig();
    return (_jsxs("section", { className: "mx-auto mb-10 text-center md:w-3/4", children: [_jsx(Text, { tag: "h2", className: cx("mt-10 mb-2 !text-4xl md:!text-6xl", brand?.classes.text.title), weight: "bold", children: title }), description && (_jsx(Text, { tag: "p", size: "lg", weight: "light", className: brand?.classes.text.description, children: description }))] }));
};
export default Banner;
//# sourceMappingURL=Banner.js.map